import {Directive, ElementRef, Inject, OnInit, Optional} from "@angular/core";
import {isApple, isMobile} from "../components/utils";
import {NInputComponent} from "../components/public_components";



@Directive({
  selector: "[focusOnDefault]"
})
export class FocusOnDefaultDirective implements OnInit {

  constructor(private el: ElementRef,
              @Inject(NInputComponent) @Optional() private nInput: NInputComponent) {
  }

  ngOnInit() {
    if (isApple() && isMobile()) {
      return;
    }
    if (this.nInput) {
      this.nInput.setFocus();
    } else {
      this.el.nativeElement.focus();
    }
  }

}
